export const operationConstants = {
    GETALLOPERATIONSLIST_REQUEST: "OPERATIONSLIST_GETALL_REQUEST",
    GETALLOPERATIONSLIST_SUCCESS: "OPERATIONSLIST_GETALL_SUCCESS",
    GETALLOPERATIONSLIST_FAILURE: "OPERATIONSLIST_GETALL_FAILURE",
};
